import { autoinject, Container } from "aurelia-dependency-injection";
import { ReelItemType } from "./../../models/reel-item";
import { ReelItemModel } from "../../models/reel-item";
import { backboneViewProperties } from "../../../decorators/backbone-properties";
import { AppEvents } from "../../../app-events";
import { ContainerHelper } from "../../../shared/helpers/container-helper";

@backboneViewProperties({
    className: "overview-document-item reel-list-item js-reel-list-item",
    tagName: "div"
})
export class ReelItemView extends Marionette.ItemView<ReelItemModel> {
    private appEvents: Backbone.Events;

    constructor(private options?) {
        super(options);
        this.appEvents = ContainerHelper.Events;
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events[`click`] = this.historyItemClicked;
        return events;
    }

    public onShow() {
        const literalType = ReelItemType[this.model.ItemType].toLocaleLowerCase();
        this.$el.addClass(`reel-item-type-${literalType}`);
    }

    private historyItemClicked(e: JQueryEventObject): void {
        if (this.model.Url) {
            this.appEvents.trigger(AppEvents.AppInsightsMyJustisGotoDocument, {});
            Backbone.history.navigate(this.model.Url, { trigger: true });
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/my-justis/views/partials/reel-item.ts